import { Button } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { DictButtonFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import { useDictionaryControl } from './useDictionaryControl';

type Props = TFormControlConnectorProps & {
  control: DictButtonFormControlViewModel;
};

const FormDictButtonControl = (props: Props) => {
  const { disabled, label, name, visible = true } = props.control;
  const onButtonClick = useDictionaryControl(props);

  return visible ? (
    <Button
      label={label}
      disabled={disabled}
      name={name}
      onClick={onButtonClick}
    />
  ) : null;
};
export default FormDictButtonControl;
